import {
  Component,
  ViewChild,
  ElementRef,
  ViewChildren,
  ChangeDetectorRef,
  HostListener,
  Renderer2,
  QueryList,
  Input,
} from '@angular/core';
import { chatMessage, ChatService, chatUser } from '../service/chat.service';
import { BehaviorSubject, firstValueFrom, Subscription } from 'rxjs';
import { CognitoService } from '../service/cognito.service';
import { ClientInterface, DispatchService } from '../service/dispatch.service';
import { ThemeService } from '../service/theme.service';
import {
  WebSocketSubscription,
  WebSocketService,
  BaseMessage,
  wsChatMessage,
} from '../service/websocket.service';
import { S3Service } from '../service/s3.service';
import { ScreenShareService } from '../service/screen-share.service';
import { Roles } from '../constants/roles';
import { DashboardService } from '../service/dashboard.service';
import { OperatorService } from '../service/operator.service';
import { UserInactivityService } from '../service/user-inactivity.service';
import { SystemMessageService } from '../service/system-message.service';


@Component({
    selector: 'chat-component',
    templateUrl: './chat-component.component.html',
    styleUrl: './chat-component.component.css',
    standalone: false
})
export class ChatComponentComponent {
  public clientContact: ClientInterface = {
    active: '',
    address: '',
    auto_collect: '',
    checked: false,
    client_id: '',
    client_logo: null,
    client_name: '',
    created: null,
    email: '',
    legal_name: '',
    modified: null,
    mws: '',
    phone_number: '',
  };
  public chatLog: any; // list of all conversation of current user
  public newMessage: string = ''; // the new message
  private targetUserSub: string = ''; // targeted user sub
  public userSub: any; // user sb of current chat user
  public currentChatUser: any; // current chat user data
  public contactList: chatUser[] | undefined; // current contact list
  public originalContactList: chatUser[] | undefined; // the original  contact list
  public chatRecipient: any; // sub of the recipient
  public previousSelection: any; // previous contact clicked
  public currentConversationID: string = ''; // the selected conversation ID
  public contactSearch = ''; // search value for contact list filtering
  @ViewChild('contactListRef') contactListElement!: ElementRef;
  @ViewChild('toggleButton', { static: false }) toggleButton!: ElementRef;
  @ViewChild('contactInfo', { static: false }) contactInfo!: ElementRef;
  @ViewChildren('contactElement') contactListElements!: QueryList<ElementRef>;
  @ViewChild('screenShareVideo')
  screenShareVideoRef!: ElementRef<HTMLVideoElement>;
  public openChatSubscription: Subscription = new Subscription(); // declare a new  subcription for chat modal
  public sendingMessage: boolean = false;
  selectedImage: string = ''; // Store the selected image URL
  isModalOpen: boolean = false; // Track if the modal is open or not
  isScreenSharing: boolean = false;
  showModal: boolean = false;
  // Ordered list of contact type keys shown in the sidebar UI.
  userTypes: string[] = [];
  // Full contact list grouped by type (e.g., client, operator, _support).
  groupedContacts: { [userType: string]: any[] } = {};
  // Filtered version of groupedContacts based on search input.
  filteredGroupedContacts: { [userType: string]: any[] } = {};
  // Client subgrouping for the client tab.
  clientGroupIds: string[] = [];
  filteredGroupedClientContacts: { [clientId: string]: any[] } = {};
  expandedClientGroup: { [clientId: string]: boolean } = {};
  selectedRole: string = '_all';
  expandedUserType: { [userType: string]: boolean } = {};
  flippedUserType: { [userType: string]: boolean } = {}; // for UI arrow up/down
  chatBanner: any;
  public isUserClient: boolean;

  public noConvo = false;
  public noMessages = false;

  //dragging and resize
  public resizing = false;
  public startTop: number = 0; // Used when resizing from top
  public startLeft: number = 0; // Used when resizing from top
  public startX = 0;
  public startY = 0;
  public startWidth = 0;
  public startHeight = 0;
  @ViewChild('chatWindow') chatWindowRef!: ElementRef<HTMLElement>;
  @Input() dragBoundary!: ElementRef;
  public showContactInfo = false; // contact info bubble status
  resizeEdge:
    | 'left'
    | 'right'
    | 'top'
    | 'bottom'
    | 'corner-top-left'
    | 'corner-bottom-right'
    | 'corner-bottom-left'
    | 'corner-top-right'
    | null = null;

  @ViewChild('messageContainer')
  messageContainerRef!: ElementRef<HTMLDivElement>;
  public isVideoModalOpen: boolean = false;
  public selectedVideoUrl: string | null = null;

  // Websocket subscription object
  private wsLiveChat: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'MESSAGE',
    callback: this.wsLiveChatChatHandler.bind(this),
  };
  // Websocket subscription object
  private wsContactListStatuses: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'CHAT_STATUS_CHANGE',
    callback: this.wsLiveChatStatusHandler.bind(this),
  };
  private wsLiveChatStatus: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'CONTACT_STATUS' /* TODO change to USERS_STATUS */,
    callback: this.wsUserStatusHandler.bind(this),
  };
  private wsScreenShareOffer: WebSocketSubscription = {
    subscriber: 'screenShareReceiver',
    messageType: 'SCREEN_SHARE_OFFER',
    callback: (msg) => this.screenShareService.handleOffer(msg),
  };
  private wsScreenShareAnswer: WebSocketSubscription = {
    subscriber: 'screenShareSender',
    messageType: 'SCREEN_SHARE_ANSWER',
    callback: (msg) => this.screenShareService.handleAnswer(msg),
  };
  private wsIceCandidate: WebSocketSubscription = {
    subscriber: 'ICE canditate',
    messageType: 'SCREEN_SHARE_CANDIDATE',
    callback: (msg) => {
      // WebRTC logic
      this.screenShareService.handleCandidate(
        msg.CONTENT['candidate']
      ); /* TODO change to CANDIDATE */
      // UI logic
      this.updateUIWithNewCandidate(
        msg.CONTENT['candidate']
      ); /* TODO change to CANDIDATE */
    },
  };
  private wsMessageReadSync: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'MESSAGE_READ_SYNC',
    callback: async (msg) => {
          //Sync read messages accross all instances of the chat
          const conversationId = msg.CONTENT['CONVERSATION_ID'];
          this.chatService.markMessageRead(conversationId);
    }
  }
  private wsMessageSync: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'MESSAGE_SYNC',
    callback: async (msg) => {
          //Sync read messages accross all instances of the chat
            //Sync messages accross all instances of the chat
          const message = msg.CONTENT['MESSAGE'];
          if (
            this.chatService.currentOpenConversation ===
            msg.CONTENT['CONVERSATION_ID']
          ) {
            const receivedMessage: chatMessage = {
              message_id:
                msg.CONTENT['MESSAGE_ID'] /* TODO Change to MESSAGE_ID */,
              conversation_id: this.currentConversationID,
              sender_sub: this.userSub,
              receiver_sub: this.chatRecipient,
              content: message,
              message_type: typeof message === 'string' ? 'text' : 'media',
              status: 'delivered',
              timestamp: `${Math.floor(Date.now() / 1000)}`,
              deleted: false,
              edited_at: '',
            };
            this.chatLog.unshift(receivedMessage); //Always put at the begining of array if not new message wont apppear in the UI because of groupMessagesByDate()
            this.groupMessagesByDate();
          }

    }
  }
  private wsNewConversation: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'NEW_CONVERSATION',
    callback: async (msg) => {
           try {
            // Convert Observable to Promise so you can truly await it
            const data: any =
              await this.chatService.getAllChatLogByUserSubAsync(this.userSub);

            this.chatService.userConvos = data ? data : [];

            this.chatService.userConvos.forEach((convo: any) => {
              this.chatService.sortMessagesByTimestamp(convo);
            });

            const conversationID = msg.CONTENT['CONVERSATION'].conversation_id;

            const newConvo = this.chatService.userConvos.find(
              (convo: any) =>
                convo.conversation.conversation_id === conversationID
            );

            if (newConvo) {
              this.currentConversationID = newConvo.conversation.conversationID;
              this.chatLog = [];
              this.groupMessagesByDate();

              this.noConvo = false;
              this.noMessages = true;
            } else {
              console.warn('New conversation not found after WS fetch');
            }
          } catch (err) {
            console.error('Failed to fetch conversation list', err);
          }
    }
  }
  private wsNewConversationSync: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'NEW_CONVERSATION_SYNC',
    callback: async (msg) => {
      //Sync new conversation UI accross all instances of the chat"
      const conversation_id = msg.CONTENT['CONVERSATION_ID'];
      if (this.chatRecipient === msg.CONTENT['RECIPIENT']) {
        this.noConvo = false;
        this.noMessages = true;
      }
      this.openConversation(conversation_id)
    }
  }
  private wsContactStatusChange: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'CONTACT_STATUS_CHANGE',
    callback: async (msg) => {
       const user = msg.CONTENT['USER'],
             newStatus = msg.CONTENT['STATUS']
    const contact = this.contactList?.find((c:any)=>{
      return c.user === user
    });
    if(contact){
      contact.status = newStatus
      }
    }
  }


  private wsLogOut: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'LOGOUT',
    callback: (msg) => {
      const user = msg.CONTENT['USER'];
      // Update both contact lists
      this.updateStatus(this.originalContactList, user, true);
      this.updateStatus(this.contactList, user, true);
    },
  };
  private wsLogIn: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'USER_LOGGED_IN',
    callback: (msg) => {
      const user = msg.CONTENT['USER']; /* TODO Change to USER */
      // Update both contact lists
      this.updateStatus(this.originalContactList, user);
      this.updateStatus(this.contactList, user);
    },
  };
  private wsMessageRead: WebSocketSubscription = {
    subscriber: 'chat_engine',
    messageType: 'MESSAGE_READ_CONFIRMATION',
    callback: async (msg: BaseMessage) => {
      const confirmation = msg as BaseMessage;
      const conversationID = confirmation.CONTENT['CONVERSATION_ID'];
      // Try Update status of message in UI locally
      let messageFound = this.markMessageAsReadLocally(conversationID);
      if (!messageFound) {
        //re-fetch from DB to guarantee the message is present
        await this.chatService.getAllChatLogByUserSubAsync(this.userSub);
        this.groupMessagesByDate();
        this.cdr.detectChanges();

        // Retry marking after DB load
        messageFound = this.markMessageAsReadLocally(conversationID);
      }
    },
  };
  groupedMessages: { dateLabel: string; messages: any[] }[] = [];
  private groupedMessagesSubject: BehaviorSubject<any[]> = new BehaviorSubject<
    any[]
  >([]);
  groupedMessages$ = this.groupedMessagesSubject.asObservable();
  isContactListOpened: boolean = false;
  currentScreenWidth: any;
  textCopied: boolean = false;
  private chatListener: any;
  public isInactive: boolean = false;
  public activeTab: any = null;
  public tabs: any[];
  private clickFromToggleButton = false;
  public selectedStatus: string = '_available';

  constructor(
    public theme: ThemeService,
    public dispatchService: DispatchService, //user contact and UI display
    private cognitoService: CognitoService, // cuurent user information
    public webSocketService: WebSocketService, // duplex connections
    public chatService: ChatService, // handles live chat
    private cdr: ChangeDetectorRef, //for UI updates
    private renderer: Renderer2, // for UI menu in mobile view,
    private screenShareService: ScreenShareService,
    private s3Service: S3Service,
    private dashboardService: DashboardService,
    private operatorService: OperatorService,
    private inactivityService: UserInactivityService,
    public systemMessageService: SystemMessageService
  ) {
    this.currentChatUser = this.chatService.currentChatUser;
    this.isUserClient = this.chatService.currentUserType === 'client';
    this.tabs = [];
  }
  // update the grouped messages when a new message is added
  updateGroupedMessages(messages: any[]): void {
    this.groupedMessagesSubject.next(messages); // Emit the updated array
  }

  async ngOnInit(): Promise<void> {
    //Get current user info
    this.originalContactList = this.chatService.originalChatUserArray ?? []; // init orginal chat user
    this.contactList = this.originalContactList; // init the contact list
    this.userSub = this.chatService.userSub; // user sub

    // Group contact by user type
    this.groupContactsByUserType();
    //   Update the local groupedMessages array
    this.groupedMessages$.subscribe((messages) => {
      this.groupedMessages = messages;
    });

    // Subscribe to the service's message observable
    this.openChatSubscription = this.chatService.message$.subscribe(
      (recipient) => {
        this.targetUserSub = recipient;
        this.openConversation(this.targetUserSub);
      }
    );
    this.currentScreenWidth = this.getScreenWidth();
    //Subscibe to necessary ws messages
    this.initWebSocketSubscriptions();

    //New listener to watch when the chat is opened
    this.chatListener = (event: CustomEvent) => {
      this.handleChatOpened(event); // Handles opening conversation that are opened in background
    };
    //Subscribe to the inactivity service to access user activity
    this.inactivityService.getUserInactiveStatus().subscribe((status) => {
      this.isInactive = status;
      //Sets inactive if status lock different than Available ig Away, Busy,Offline
      if (
        this.inactivityService.statusLock &&
        this.inactivityService.statusLock != '_available'
      ) {
        this.isInactive = true;
      }

      if (this.isInactive) {
        //Send WS for 5 min inactivity
      }
      //console.log('user afk? ', this.isInactive);
    });
    //Subscribe to the selected status to handle message read
    this.inactivityService
      .getUserSelectedStatus()
      .subscribe((selectedStatus) => {
        this.selectedStatus = selectedStatus;
        // If user became avaialbe
        if (
          selectedStatus === 'Available' &&
          this.currentConversationID &&
          this.chatService.isChatModalOpen
        ) {
          //Check for unread messages
          const unreadConvo = this.chatService.getUnreadByConvoId(
            this.currentConversationID
          );
          if (unreadConvo) {
            // Send read notification
            unreadConvo.messages.forEach((msg) => {
              const wsReadReceipt = {
                DISPATCH: 'CHAT',
                ACTION: 'MESSAGE_READ',
                CONTENT: {
                  MESSAGE_ID: msg /* TODO change to MESSAGE_ID*/,
                  READER: this.userSub,
                  SENDER: this.chatRecipient,
                  CONVERSATION_ID: unreadConvo.convoId,
                },
              };
              //send read receipt
              this.webSocketService.send(wsReadReceipt);
            });
            //Updates UI and sync
            this.chatService.markMessageRead(this.currentConversationID);
            this.chatService.initMessageReadSync(this.currentConversationID);
          } else {
          }
        }
      });
    //Disable scrolling outside  chat modal when visible
    this.chatService.isChatModalOpen$.subscribe((isOpen) => {
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    window.addEventListener('chatOpened', this.chatListener as EventListener);
    //Count application user for all types to get access to data for UI
    await this.dashboardService.countApplicationClients();
    await this.dashboardService.countApplicationOperators();
    await this.dashboardService.countApplicationDistributors();
  }

  ngAfterViewInit(): void {
    // Ensure the contact list is not empty
    if (this.contactListElements && this.contactListElements.length > 0) {
      let nativeEl = this.contactListElements.find(
        (contactElRef: ElementRef) => {
          return contactElRef.nativeElement?.id === this.targetUserSub;
        }
      );
      if (nativeEl) {
        // Apply background color safely
        nativeEl.nativeElement.style.backgroundColor = '#2c2f31';
      } else {
        console.warn('No element found with the specified ID');
      }
    } else {
      console.warn('No contact elements found');
    }
  }

  ngOnDestroy(): void {
    //Unsuscribe to necessary ws messages
    this.destroyWebSocketSubscriptions();
    if (this.openChatSubscription) {
      this.openChatSubscription.unsubscribe(); // Unsubscribe to openchat subscription prevent memory leaks
    }
    this.chatService.clearUsers(); //clear the chat contact users
    this.isContactListOpened = false;
    window.removeEventListener(
      'chatOpened',
      this.chatListener as EventListener
    );
  }

  @HostListener('wheel', ['$event'])
  onWheelScroll(event: WheelEvent) {
    const target = event.target as HTMLElement;
    const container = target.closest(
      '.conversation-tabs'
    ) as HTMLElement | null;
    // Exit if not hovering over the tabs container
    if (!container) {
      return;
    }

    // Only scroll horizontally if the container is scrollable
    const isScrollable = container.scrollWidth > container.clientWidth;
    if (!isScrollable) {
      return;
    }

    // Only apply horizontal scrolling if there's a deltaY
    if (event.deltaY !== 0) {
      // Prevent vertical scroll only if horizontal scroll is possible if not page scrolls in background
      event.preventDefault();
      container.scrollLeft += event.deltaY;
    }
  }
  // Event listener for chat closure on esp keydown
  @HostListener('window:keydown', ['$event'])
  /**
   * Function that closes chat on "Esc" key press
   */
  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape' && this.chatService.isChatModalOpen) {
      this.closeModal();
    }
  }
  // Event listener for window resize
  @HostListener('window:resize', ['$event'])
  /**
   * Function that get the current screen width
   */
  onWindowResize(event: any): void {
    this.currentScreenWidth = this.getScreenWidth();
  }

  /**
   * Host listener that checks for click events
   */
  @HostListener('document:click', ['$event'])
  /**
   * Handles click events on the document to determine if a user clicked outside
   * specific UI components, closes the relevant UI
   * if the user clicks outside while it is open.
   *
   * @param event MouseEvent - The mouse click event from the DOM.
   */
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    // Check if the click occurred inside the contact list sidebar
    const clickedInsideSidebar =
      this.contactListElement?.nativeElement.contains(target);

    // Check if the click occurred on the toggle button for the contact list
    const clickedToggleButton =
      this.toggleButton?.nativeElement.contains(target);

    // Check if the click occurred inside the contact info panel
    const clickedInsideContactInfo =
      this.contactInfo?.nativeElement.contains(target);

    // Prevent closing if the click originated from the toggle button
    if (this.clickFromToggleButton) {
      this.clickFromToggleButton = false; // Reset flag for future clicks
      return;
    }

    // Close the contact list if it is open and the user clicked outside of it
    if (
      this.isContactListOpened &&
      !clickedInsideSidebar &&
      !clickedToggleButton
    ) {
      this.closeContact();
      return;
    }

    // Close the contact info panel if it's visible and the click occurred outside of it
    if (this.showContactInfo && !clickedInsideContactInfo) {
      this.showContactInfo = false;
      return;
    }
  }

  // Event listener for document mousemove (for chat window resizing)
  @HostListener('document:mousemove', ['$event'])
  /**
   * Function that handled the chat window resizing
   */
  onDocumentMouseMove(event: MouseEvent): void {
    // Exit early if no resize is currently happening
    if (!this.resizing) {
      return;
    }
    // Get a reference to the DOM element representing the chat window
    const chatElement = this.chatWindowRef.nativeElement;
    // Calculate how far the mouse has moved
    let deltaX = event.clientX - this.startX;
    let deltaY = event.clientY - this.startY;
    // Initialize new dimensions and position using the starting values
    let newWidth = this.startWidth;
    let newHeight = this.startHeight;
    let newLeft = this.startLeft;
    let newTop = this.startTop;
    // Define min/max size constraints
    const minWidth = 400;
    const minHeight = 440;
    const maxWidth = 945;
    const maxHeight = 530;

    // Resize from the right edge
    if (this.resizeEdge === 'right') {
      newWidth = Math.min(
        maxWidth,
        Math.max(minWidth, this.startWidth + deltaX)
      );
    }
    // Resize from the left edge
    else if (this.resizeEdge === 'left') {
      newWidth = Math.min(
        maxWidth,
        Math.max(minWidth, this.startWidth - deltaX)
      );
      if (newWidth >= minWidth) {
        newLeft = this.startLeft + (this.startWidth - newWidth);
      }
    }
    // Resize from the bottom edge
    else if (this.resizeEdge === 'bottom') {
      newHeight = Math.min(
        maxHeight,
        Math.max(minHeight, this.startHeight + deltaY)
      );
    }
    // Resize from the top edge
    else if (this.resizeEdge === 'top') {
      newHeight = Math.min(
        maxHeight,
        Math.max(minHeight, this.startHeight - deltaY)
      );
      if (newHeight > minHeight && newHeight < maxHeight) {
        newTop = this.startTop + deltaY; // Adjust top position
      }
      // Handle  height boundaries
      if (newHeight === maxHeight) {
        newTop = this.startTop - deltaY;
        return;
      }
      if (newHeight === minHeight) {
        newTop = this.startTop + deltaY;
        return;
      }
    }
    // Resize from top-left corner
    else if (this.resizeEdge === 'corner-top-left') {
      newHeight = Math.min(
        maxHeight,
        Math.max(minHeight, this.startHeight - deltaY)
      );
      newWidth = Math.min(
        maxWidth,
        Math.max(minWidth, this.startWidth - deltaX)
      );
      if (newWidth >= minWidth) {
        newLeft = this.startLeft + (this.startWidth - newWidth);
      }

      if (newHeight > minHeight && newHeight < maxHeight) {
        newTop = this.startTop + deltaY;
      }
      if (newHeight === maxHeight) {
        newTop = this.startTop - deltaY;
        return;
      }
      if (newHeight === minHeight) {
        newTop = this.startTop + deltaY;
        return;
      }
    }
    // Resize from top-right corner
    else if (this.resizeEdge === 'corner-top-right') {
      newHeight = Math.min(
        maxHeight,
        Math.max(minHeight, this.startHeight - deltaY)
      );
      newWidth = Math.min(
        maxWidth,
        Math.max(minWidth, this.startWidth + deltaX)
      );
      if (newHeight > minHeight && newHeight < maxHeight) {
        newTop = this.startTop + deltaY;
      }
      if (newHeight === maxHeight) {
        newTop = this.startTop - deltaY;
        return;
      }
      if (newHeight === minHeight) {
        newTop = this.startTop + deltaY;
        return;
      }
    }
    // Resize from bottom-left corner
    else if (this.resizeEdge === 'corner-bottom-left') {
      newHeight = Math.min(
        maxHeight,
        Math.max(minHeight, this.startHeight + deltaY)
      );
      newWidth = Math.min(
        maxWidth,
        Math.max(minWidth, this.startWidth - deltaX)
      );
      if (newWidth >= minWidth) {
        newLeft = this.startLeft + (this.startWidth - newWidth);
      }
    }
    // Resize from bottom-right corner
    else if (this.resizeEdge === 'corner-bottom-right') {
      newHeight = Math.min(
        maxHeight,
        Math.max(minHeight, this.startHeight + deltaY)
      );
      newWidth = Math.min(
        maxWidth,
        Math.max(minWidth, this.startWidth + deltaX)
      );
    }

    // Apply new dimensions and position to the chat element
    chatElement.style.width = `${newWidth}px`;
    chatElement.style.height = `${newHeight}px`;
    chatElement.style.left = `${newLeft}px`;
    this.chatService.chatDimensions = {
      width: newWidth,
      height: newHeight,
    };
    localStorage.setItem(
      'chatDimensions',
      JSON.stringify(this.chatService.chatDimensions)
    );
    chatElement.style.top = `${newTop}px`;
  }

  @HostListener('document:mouseup')
  /**
   * Function that remove any active interaction classes
   * of drag or resize
   */
  onDocumentMouseUp(): void {
    if (this.chatWindowRef && this.chatWindowRef.nativeElement) {
      this.chatWindowRef.nativeElement.classList.remove('dragging', 'resizing');
    }
    // Reset flags
    this.resizing = false;
  }

  /**
   * Function to get the current screen width
   * @returns
   */
  getScreenWidth(): number {
    // Return the inner width of the window as the screen width
    return window.innerWidth;
  }

  /**
   *  Helper function to set online/offline status in contact list
   * @param list the contact list
   * @param username the sub of the specific contact
   * @param logout current status
   */
  updateStatus(list: any, usersub: any, logout: boolean = false): void {
    const user = list?.find((u: any) => u.user === usersub);
    if (user && logout) {
      user.status = false;
    } else {
      user.status = true;
    }
  }

  /**
   * Function that group all mesages in conversation per date
   */
  groupMessagesByDate(): void {
    const grouped: { dateLabel: string; messages: any[] }[] = [];
    let currentDate: string | null = '';
    // Loop through all messages
    this.chatLog?.forEach((message: any) => {
      const messageDate = new Date(message.timestamp * 1000); // Convert to JavaScript Date
      const dateLabel = this.getDateLabel(messageDate); // Get teh date label
      // Check if the group for the current date exists
      let existingGroup = grouped.find(
        (group) => group.dateLabel === dateLabel
      );
      // If the date is different from the last message, start a new group
      if (dateLabel !== currentDate && !existingGroup) {
        currentDate = dateLabel;
        grouped.push({ dateLabel, messages: [message] });
      }
      // If the date is the same from the last message
      if (dateLabel === currentDate && existingGroup) {
        // Add the message to the existing group
        existingGroup.messages.push(message);
      }
    });

    // Sort messages within each group by timestamp (newest last)
    grouped.forEach((group) => {
      group.messages.sort((a, b) => a.timestamp - b.timestamp);
    });
    this.groupedMessages = grouped;
    this.sortGroupMesage(this.groupedMessages); // sort all message GROUPS
    this.updateGroupedMessages(this.groupedMessages); // update the observebal
  }

  /**
   * Function that sorts message goups chronoigically dsc
   */
  sortGroupMesage(groupMessage: any): void {
    // Sort the messages array
    groupMessage.sort((a: any, b: any) => {
      // First, prioritize "Today" and "Yesterday"
      if (a.dateLabel === 'Today') return -1;
      if (b.dateLabel === 'Today') return 1;
      if (a.dateLabel === 'Yesterday') return -1;
      if (b.dateLabel === 'Yesterday') return 1;

      // For other dates, we compare the actual dates
      const aDate = new Date(a.dateLabel);
      const bDate = new Date(b.dateLabel);

      // Sort by date descending (newest first)
      return bDate.getTime() - aDate.getTime();
    });
  }
  /**
   * Convert a timestamp to a date label (Today, Yesterday, or specific date)
   * @param date
   * @returns date formated toLocaleDateString()
   */
  getDateLabel(date: Date): string {
    const now = new Date();

    // Reset the time portion to midnight for both 'now' and 'date' to compare only the dates
    now.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    const diff = now.getTime() - date.getTime();
    const diffDays = Math.floor(diff / (1000 * 3600 * 24)); // Calculate difference in days

    if (diffDays === 0) {
      return 'Today';
    } else if (diffDays === 1) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString(); // For older dates, return the full date string
    }
  }

  /**
   * Marks a message as read locally within the relevant conversation.
   * @param conversationID - The ID of the conversation containing the message.
   * @param messageID - The ID of the message to mark as read.
   */
  markMessageAsReadLocally(conversationID: string): boolean {
    // Find the relevant conversation group
    const conversationGroup = this.groupedMessages.find((group: any) => {
      return group.messages.some(
        (msg: any) => msg.conversation_id === conversationID
      );
    });
    if (!conversationGroup) {
      console.warn(`No conversation found for ID: ${conversationID}`);
      return false;
    }
  // Track whether any message was updated
  let updated = false;

  // Update all messages in the conversation with status 'delivered'
  for (const msg of conversationGroup.messages) {
    if (msg.conversation_id === conversationID && msg.status === 'delivered') {
      msg.status = 'read';
      updated = true;
    }
  }

  // Re-group the UI only if something was updated
  if (updated) {
    this.groupMessagesByDate();
    return true;
  }

  return false;

  }

  /**
   * Function that handles messages received from the WS
   * @param message: the message received from WS
   */
  async wsLiveChatChatHandler(message: BaseMessage): Promise<void> {
    const chatMessage = message as wsChatMessage; // recuperate message
    // create a chat message based on WS message
    let receivedMessage = this.createReceivedMessage(chatMessage);
    //If the received message belong to open conversation
    if (
      this.chatService.currentOpenConversation ===
        receivedMessage.conversation_id &&
      this.chatService.isChatModalOpen
    ) {
      //Add new message to chat log for future sorting
      this.chatLog.unshift(receivedMessage); // Important to put it at the begining or array
      // After message added to correct conversation

      if (!this.isInactive && this.selectedStatus === 'Available') {
        // Send read receipts only when user tab is active
        const wsReadReceipt = {
          DISPATCH: 'CHAT',
          ACTION: 'MESSAGE_READ',
          CONTENT: {
            MESSAGE_ID: chatMessage.CONTENT['MESSAGE_ID'],
            READER: this.userSub,
            SENDER: this.chatRecipient,
            CONVERSATION_ID: this.currentConversationID,
          },
        };
        //send read receipt
        this.webSocketService.send(wsReadReceipt);
        this.chatService.initMessageReadSync(this.currentConversationID);
      } else {
        this.chatService.addUnread(
          receivedMessage.conversation_id,
          receivedMessage.message_id
        );
      }
      // Find and open the new conversation by ID
      const conversationID =
        receivedMessage.conversation_id ||
        chatMessage.CONTENT['CONVERSATION_ID'];
      if (conversationID) {
        const newConvo = this.chatService.userConvos.find((convo: any) => {
          return convo.conversation.conversation_id === conversationID;
        });
        if (newConvo) {
          this.currentConversationID = conversationID;
          this.groupMessagesByDate();
        } else {
          console.warn('Conversation not found after receiving message');
        }
      }
    } else {
      this.chatService.addUnread(
        receivedMessage.conversation_id,
        receivedMessage.message_id
      );
      await this.chatService.getAllChatLogByUserSubAsync(this.userSub);
    }
  }

  /**
   * Function that updates online statuses from the WS
   * @param message: the message received from WS
   */
  async wsUserStatusHandler(message: BaseMessage): Promise<void> {
    let chatUser =
      message['CONTENT']['CHAT_CONTACTS']; /* TODO change to CHAT_USER*/
    chatUser.forEach((chatUser: any) => {
      // Now, for each chatUser, find the corresponding contact
      let contact = this.contactList?.find((contact) => {
        return contact.user === chatUser.client;
      });
      if (contact) {
        contact.status = chatUser.status;
      }
    });
  }

  /**
   * Function that closes the chat modal
   */
  closeModal(): void {
    // this.chatService.currentOpenConversation = ''; // reset current open conversation
    this.chatService.isChatModalOpen = false;
    this.chatService.toggleChat();
  }

  /**
   * getter for UI create conversation view
   */
  get showCreateConvo(): boolean {
    const hasRecipient = this.chatRecipient;
    const noConversation = !this.currentConversationID;
    const isChatLogEmpty = this.chatLog?.length === 0;

    return hasRecipient && noConversation && isChatLogEmpty;
  }

  /**
   * getter for UI slect a contact view
   */
  get showSelectUser(): boolean {
    return (
      !this.chatRecipient &&
      !this.currentConversationID &&
      this.chatLog === undefined
    );
  }

  /**
   * getter for UI no message view
   */
  get showNoMessages(): boolean {
    const noConversation = !this.currentConversationID;
    const isChatLogEmpty = this.chatLog?.length === 0;
    return !noConversation && isChatLogEmpty;
  }
  /**
   * Function that opens a conversation
   */
  async openConversation(input: string): Promise<void> {
    let conversation: any;
    let contactSub: string | null = null;

    // Fetch latest conversations
    await this.chatService.getAllChatLogByUserSubAsync(this.userSub);

    // 1. Try to match input as a conversation ID
    conversation = this.chatService.userConvos.find(
      (convo: any) => convo.conversation.conversation_id === input
    );

    if (conversation) {
      // We got the conversation directly
      this.currentConversationID = conversation.conversation.conversation_id;

      // Determine the contact (other user)
      contactSub =
        conversation.conversation.userSub_1 === this.userSub
          ? conversation.conversation.userSub_2
          : conversation.conversation.userSub_1;
    } else {
      // No conversation ID match handles input as userSub
      contactSub = input;

      // Try to find conversation with that contact
      conversation = this.chatService.userConvos.find((convo: any) => {
        const u1 = convo.conversation.userSub_1;
        const u2 = convo.conversation.userSub_2;
        return (
          (u1 === contactSub && u2 === this.userSub) ||
          (u2 === contactSub && u1 === this.userSub)
        );
      });

      this.currentConversationID =
        conversation?.conversation?.conversation_id ?? null;
    }

    // Set recipient and UI banner info
    if (contactSub) {
      this.chatRecipient = contactSub;
      this.highlightSelectedContact(contactSub);
      this.chatBanner = this.contactList?.find((c) => c.user === contactSub);
    }

    // Set chat log
    this.chatLog = conversation?.messages ?? [];

    // Sort all conversations
    this.chatService.userConvos.forEach((convo: any) => {
      this.chatService.sortMessagesByTimestamp(convo);
    });

    // Set flags
    this.noConvo = !this.currentConversationID;
    this.noMessages = !!this.currentConversationID && this.chatLog.length === 0;

    // Track open conversation
    this.chatService.currentOpenConversation = this.currentConversationID;

    // Process messages
    this.groupMessagesByDate();
    this.sendReadReceiptsForCurrentConversation();

    // Responsive design toggle
    if (this.currentScreenWidth <= 620) {
      this.toggleContact();
    }

    // Screen sharing setup
    if (this.chatRecipient) {
      this.screenShareService.initialize(
        this.userSub,
        this.chatRecipient,
        this.screenShareVideoRef
      );
    }
    //Chat tabs set up
    const tab = {
      conversation: this.currentConversationID,
      recipient: `${this.chatBanner.given_name}  ${this.chatBanner.family_name}`,
      sub: this.chatRecipient,
    };
    //Only push if it doesn't already exist
    const alreadyOpen = this.tabs.some((t) => t.sub === this.chatRecipient);

    if (!alreadyOpen) {
      this.tabs.push(tab);
    }
    this.activeTab = tab;
    this.showContactInfo = false;
    this.closeContact();
  }

  /**
   * Function that sends read receipts for all delivered messages of a conversation
   *
   */
  sendReadReceiptsForCurrentConversation(): void {
    let messagesToMark: string[] = [],
        isUnreadFromRecipient = false;

   for (const group of this.groupedMessages ?? []) {
  for (const msg of group.messages) {
    if (
      msg.status === 'delivered' &&
      msg.sender_sub === this.chatRecipient
    ) {
      messagesToMark.push(msg.message_id);
      isUnreadFromRecipient = true;
      break; // stop inner loop
    }
  }
  if (isUnreadFromRecipient) break; // stop outer loop once a message is marked
}
  //Sends one message that updates all unread messages if one found
    if (messagesToMark.length > 0) {
        try {
         const wsReadReceipt = {
        DISPATCH: 'CHAT',
        ACTION: 'MESSAGE_READ',
        CONTENT: {
          READER: this.userSub,
          SENDER: this.chatRecipient,
          CONVERSATION_ID: this.currentConversationID,
        },
      };

        this.webSocketService.send(wsReadReceipt);
      } catch (err) {
        console.error('[ERROR] Sending read receipt:', err);
      }

      this.chatService.markMessageRead(this.currentConversationID);
      this.chatService.initMessageReadSync(this.currentConversationID);
    }
  }

  //
  /**
   * Function that get the number of unread messages
   * @param contactUserSub the sub of the contact to check for unread messages
   * @returns the number of unread messages
   */
  getUnreadCountForContact(contactUserSub: string): number {
    const convo = this.chatService.userConvos.find((c: any) => {
      return (
        (c.conversation.userSub_1 === contactUserSub &&
          c.conversation.userSub_2 === this.userSub) ||
        (c.conversation.userSub_2 === contactUserSub &&
          c.conversation.userSub_1 === this.userSub)
      );
    });

    const convoId = convo?.conversation.conversation_id;
    if (!convoId) return 0;

    return this.chatService.getUnreadCount(convoId);
  }

  /**
   * Functio that checks if any contact in a role has unread messages
   * @param type
   * @returns boolean indicating if there are unread messages
   */
  hasUnreadInType(type: string): boolean {
    if (type === '_all') {
      return false;
    } // exclude the all category

    const contacts = this.filteredGroupedContacts[type] || [];

    return contacts.some(
      (contact) => this.getUnreadCountForContact(contact.user) > 0
    );
  }
  /**
   * Function that hightlights selected contact in the list
   * @param  contact: the contact to highlight
   */
  highlightSelectedContact(contactId: string): void {
    if (this.previousSelection) {
      this.previousSelection.classList.remove(
        'selected',
        ...this.theme.themeStatus.split(' ')
      );
    }

    const nativeEl = this.contactListElements.find((ref: ElementRef) => {
      return ref?.nativeElement?.id === contactId;
    })?.nativeElement;

    if (nativeEl) {
      this.previousSelection = nativeEl;

      const themeClasses = this.theme.themeStatus.split(' '); // ['bg-dark', 'text-white'] or ['bg-light', 'text-dark']
      nativeEl.classList.add('selected', ...themeClasses);
    }
  }

  /**
   * Function that sends a chat message
   */
  async sendMessage(msg?: chatMessage) {
    await this.sendMessageInternal(msg);
  }

  // Persists a message first, then pushes it through WS and updates the UI state.
  async sendMessageInternal(msg: chatMessage | undefined) {
    if ((this.newMessage && this.newMessage.trim() !== '') || msg) {
      //Create the message object
      const message: chatMessage = {
        message_id: msg?.message_id || '',
        conversation_id: msg?.conversation_id || this.currentConversationID,
        sender_sub: msg?.sender_sub || this.userSub,
        receiver_sub: msg?.receiver_sub || this.chatRecipient,
        content: msg?.content || this.newMessage,
        message_type:
          msg?.message_type ||
          (typeof (msg?.content || this.newMessage) === 'string'
            ? 'text'
            : 'media'),
        status: msg?.status || 'delivered',
        timestamp: msg?.timestamp || `${Math.floor(Date.now() / 1000)}`,
        deleted: msg?.deleted || false,
        edited_at: msg?.edited_at || '',
      };
      if (
        (this.newMessage && this.newMessage != ' ') ||
        (msg?.content && msg?.content != ' ')
      ) {
        // Save message to database first
        try {
          const response = (await firstValueFrom(
            this.chatService.sendMessage(message)
          )) as any;
          // Only after DB save succeeds, update UI
          const messageID = response?.messageID;
          let conversationToAdd = this.groupedMessages.find((convo: any) => {
            const today = new Date();
            return convo.dateLabel === this.getDateLabel(today);
          });

          if (conversationToAdd) {
            conversationToAdd.messages.push(message);
          } else {
            const createdGroup = {
              dateLabel: this.getDateLabel(new Date()),
              messages: [message],
            };
            createdGroup.messages.sort((a, b) => +a.timestamp - +b.timestamp);
            this.groupedMessages = [createdGroup, ...this.groupedMessages];
          }

          // Then send the message via WebSocket
          const wsMessage: wsChatMessage = {
            ACTION: 'MESSAGE',
            CONTENT: {
              TARGETS: [this.chatRecipient],
              SENDER: this.userSub,
              CONVERSATION_ID: this.currentConversationID,
              MESSAGE: msg?.content || this.newMessage,
              MESSAGE_ID: messageID,
            },
            DISPATCH: 'CHAT'
          };
          this.webSocketService.send(wsMessage);

          try {
            const chatLogData = await firstValueFrom(
              this.chatService.getAllChatLogByUserSub(this.userSub)
            );
            this.chatService.userConvos = chatLogData || [];
            this.chatService.userConvos.forEach((convo: any) => {
              this.chatService.sortMessagesByTimestamp(convo);
            });
            //Replace chatLog with the latest messages for the current convo
            const latestMessages =
              this.chatService.userConvos.find(
                (convo: any) =>
                  convo.conversation.conversation_id ===
                  this.currentConversationID
              )?.messages ?? [];
            this.chatLog = latestMessages;
            this.groupMessagesByDate();
            // Update UI after DB re-fetch
            this.updateGroupedMessages(this.groupedMessages);
          } catch (error) {
            console.error('Error sending message: ', error);
          }

          // Reset message input
          this.newMessage = '';
          this.sendingMessage = false;
          //Insure view adapts when first message of conversation is sent
          if(this.noMessages){
            this.noMessages = false;
          }
        } catch (error) {
          console.error('Error sending message: ', error);
        }
      }
    }
  }
  /**
   * Function that get the name of contact based on the sub
   * @param sub : the sub of the client to retrieve the name of
   * @returns contact  name
   */
  getContactDisplayName(sub: string): string {
    let contact = this.contactList?.find((contact) => {
      return contact.user === sub;
    });
    let name = `${contact?.given_name} ${contact?.family_name}`;
    return name;
  }

  /**
   * Function that handles a new conversation creation set up
   * @param targetSub the sub of the contact with the new conversation
   */
  async finalizeNewConversationSetup(targetSub: string): Promise<void> {
    this.chatLog = [];

    const convo = this.chatService.userConvos.find((convo: any) => {
      return (
        (convo.conversation.userSub_1 === targetSub &&
          convo.conversation.userSub_2 === this.userSub) ||
        (convo.conversation.userSub_1 === this.userSub &&
          convo.conversation.userSub_2 === targetSub)
      );
    });

    if (convo) {
      this.currentConversationID = convo.conversation.conversation_id;
      this.chatLog = convo.messages ?? [];
      this.groupMessagesByDate(); // Also updates UI via updateGroupedMessages

      this.noConvo = false;
      this.noMessages = true;
    } else {
      console.warn('Could not find conversation just created');
    }
  }

  /**
   * Function that create a new conversation with a user
   * @param targetSub : the sub of the recipient
   */
  async createConversation(targetSub: string): Promise<void> {
    const data = await firstValueFrom(
      this.chatService.createConvo(this.userSub, targetSub)
    );

    if (data) {
      const newConversation =
        data?.existingConversation?.conversation_id || data.newConversation?.[0];
      this.currentConversationID = newConversation;
      await this.chatService.getAllChatLogByUserSubAsync(this.userSub);

      if (this.chatService.userConvos.length > 0) {
        //Sort each conversation’s messages
        this.chatService.userConvos.forEach((convo: any) => {
          this.chatService.sortMessagesByTimestamp(convo);
        });
      }

      this.chatLog = [];
      // Finalize setup: find the convo, set convo ID, group messages
      await this.finalizeNewConversationSetup(targetSub);

      let wsNewConvoMessage = {
        DISPATCH: 'CHAT',
        ACTION: 'NEW_CONVERSATION',
        CONTENT: {
          TARGET: this.chatRecipient,
          SENDER: this.userSub,
          CONVERSATION: newConversation,
        },
      };

      this.webSocketService.send(wsNewConvoMessage);
    }

    await this.openConversation(targetSub);
  }
  /**
   * Function that creates a chat message based on WS message
   * @param content: the content of the message
   */
  createReceivedMessage(content: wsChatMessage): chatMessage {
    const fileExtensions = [
      // image
      'jpg',
      'jpeg',
      'png',
      'gif',
      'webp',
      'bmp',
      'tiff',
      'svg',
      'ico',

      // text
      'bat',
      'c',
      'cpp',
      'cs',
      'doc',
      'docx',
      'env',
      'go',
      'h',
      'hpp',
      'htm',
      'html',
      'ini',
      'java',
      'js',
      'json',
      'log',
      'md',
      'odt',
      'pdf',
      'php',
      'ps1',
      'py',
      'rb',
      'rs',
      'rtf',
      'sh',
      'sql',
      'ts',
      'txt',
      'xml',
      'yaml',
      'yml',

      // spreadsheet
      'xls',
      'xlsx',
      'csv',
      'ods',

      // audio
      'mp3',
      'wav',
      'ogg',
      'm4a',
      'flac',
      'aac',
      'wma',

      // video
      'mp4',
      'mov',
      'avi',
      'wmv',
      'webm',
      'mkv',
      'flv',
      'm4v',

      // archive
      'zip',
      'rar',
      '7z',
      'tar',
      'gz',
    ];
    let matchedExtension =
      fileExtensions.find((ext) =>
        content.CONTENT['MESSAGE'].endsWith(`.${ext}`)
      ) || 'text';
    const message: chatMessage = {
      message_id: content.CONTENT['MESSAGE_ID'] ?? '',
      conversation_id: content.CONTENT['CONVERSATION_ID'],
      sender_sub: this.chatRecipient,
      receiver_sub: this.userSub,
      content: content.CONTENT['MESSAGE'],
      message_type: matchedExtension,
      status: 'read',
      timestamp: `${Math.floor(Date.now() / 1000)}`, //timestamp in seconds
      deleted: false,
      edited_at: '',
    };
    return message;
  }
  /**
   * Function that return formatted time of a chat message
   * @param timestamp the timestamp to convert
   */
  getMessageTime(timestamp: string): string {
    const date = new Date(Number(timestamp) * 1000);
    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
    return formattedTime;
  }

  /**
   * Function that expands a sub-list of contact based on user type in the UI
   * @param userType: the user type to toggle
   */
  toggleUserType(userType: string): void {
    //Toggles state of the sub-list
    this.expandedUserType[userType] = !this.expandedUserType[userType];
  }

  toggleClientGroup(clientId: string): void {
    this.expandedClientGroup[clientId] = !this.expandedClientGroup[clientId];
  }
  /**
   * Function that groups contacts in sub-lists based on user type
   */
  groupContactsByUserType(): void {
    //If no contact list safely exit
    if (!this.contactList?.length) {
      return;
    }
    //Initalize neccesary arrays
    this.groupedContacts = { _all: [] };
    this.filteredGroupedContacts = { _all: [] }; //For filtering
    this.userTypes = ['_all'];
    let supportChannelCount = 1;

    if (this.isUserClient && !this.groupedContacts['client']) {
      this.groupedContacts['client'] = [];
      this.filteredGroupedContacts['client'] = [];
      this.userTypes.push('client');
      this.expandedUserType['client'] = false;
    }

    const currentEntityId = this.getCurrentClientEntityId();
    for (const contact of this.contactList) {
      const contactUserType = contact?.user_type?.trim().toLowerCase() || '';
      const isMuirwood = contactUserType === 'muirwood';
      const isClient = contactUserType === 'client';
      const isSameClient =
        (contact.associated_entity_id || '') === currentEntityId;
      if (this.isUserClient && currentEntityId) {
        if (!isMuirwood && (!isClient || !isSameClient)) {
          continue;
        }
      } else if (this.isUserClient) {
        if (!isMuirwood && !isClient) {
          continue;
        }
      }
      //Loop through contact list to initialzie the sub-lists
      let userType = (contact.user_type || 'unknown').trim().toLowerCase();
      //Creates support channel for Client users
      if (this.isUserClient && userType === 'muirwood') {
        userType = '_support';
        contact.given_name = 'Channel';
        contact.family_name = supportChannelCount.toString();
        supportChannelCount++;
      }
      if (!this.groupedContacts[userType]) {
        //If sub-list dont exist create it
        this.groupedContacts[userType] = [];
        this.filteredGroupedContacts[userType] = [];
        this.userTypes.push(userType);
        this.expandedUserType[userType] = false;
      }
      //Add contact to necessary arrays
      this.groupedContacts[userType].push(contact);
      this.groupedContacts['_all'].push(contact);
    }

    //Ensure support channel is always the last item
    const supportIndex = this.userTypes.indexOf('_support');
    if (supportIndex && supportIndex > -1) {
      this.userTypes.splice(supportIndex, 1);
      this.userTypes.push('_support');
    }
    this.updateClientGroups(this.groupedContacts['client'] || []);
    //Filters list to update it
    this.onContactFilterChange();
  }

  /**
   * Function that flips an html element by 180 deg
   * @param icon the HTML element to flip, usualy an icon
   */
  toggleFlipped(icon: HTMLElement): void {
    icon.classList.toggle('flipped');
  }

  /**
   * Function that triggers the file input
   */
  attachFile(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput?.click(); // Programmatically click the file input
  }

  /**
   * Function that triggers the image input
   */
  addPicture(): void {
    const imgInput = document.getElementById('imageInput') as HTMLInputElement;
    imgInput?.click(); // Programmatically click the image input
  }

  /**
   * Function that opens or closes the contact list
   */
  toggleContact(): void {
    this.clickFromToggleButton = true;
    //If contact list open
    if (this.isContactListOpened)
      this.renderer.addClass(
        this.contactListElement.nativeElement,
        'contactClosed'
      );
    //If contact list closed
    if (!this.isContactListOpened)
      this.renderer.removeClass(
        this.contactListElement.nativeElement,
        'contactClosed'
      );
    //Toggle state
    this.isContactListOpened = !this.isContactListOpened;
  }

  /**
   * Function that closes the chat contact list
   */
  closeContact(): void {
    if (this.isContactListOpened) {
      this.isContactListOpened = !this.isContactListOpened;
      this.renderer.addClass(
        this.contactListElement.nativeElement,
        'contactClosed'
      );
    }
  }

  //Listend for ecp key press to close the chat
  @HostListener('document:keydown.escape')
  handleEscape(): void {
    if (this.chatService.isChatModalOpen) this.closeModal();
  }

  /**
   * Function that handles filw submission
   * @param event contains the submitted file
   * @returns
   */
  async onFileSelected(event: any): Promise<void> {
    //Recuperate the file
    const file = event.target.files[0];
    //Safely exit if file is invalid
    if (!file) {
      return;
    }

    //Set up file date: date, name and key
    const timestamp = Date.now();
    const sanitizedFileName = file.name.replace(/\s+/g, '_');
    const fileKey = `${this.userSub}/${this.currentConversationID}/${timestamp}_${sanitizedFileName}`;

    try {
      // Upload to S3
      await this.s3Service.uploadFileToS3(file, fileKey, file.type);
      const message_type = this.getMessageTypeFromMime(file);
      // Prepare message object
      const message: chatMessage = {
        message_id: '',
        conversation_id: this.currentConversationID,
        sender_sub: this.userSub,
        receiver_sub: this.chatRecipient,
        content: fileKey, // S3 URL
        message_type: message_type,
        status: 'delivered',
        timestamp: `${Math.floor(Date.now() / 1000)}`,
        deleted: false,
        edited_at: '',
      };
      //Send file message via ws
      this.sendMessage(message);
    } catch (error) {
      console.error('Upload failed:', error);
    }
  }

  /**
   * Function that dowloads a file from message feed when use click on the link
   * @param fileKey key of the file to download
   */
  async downloadFile(fileKey: string): Promise<void> {
    try {
      //Get the file from s3
      const s3File = await this.s3Service.getFileFromS3(fileKey);
      if (!s3File || !s3File.Body) {
        //Safely exit if file not found
        alert('File not found.');
        return;
      }
      // Create a Blob from the downloaded S3 file content
      const blob = new Blob([s3File.Body as BlobPart], {
        type: s3File.ContentType || 'application/octet-stream',
      });
      // Create an a tag and temporary url
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileKey.split('/').pop() || 'download';

      //trigger dowload and clean up the temporary URL
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed', error);
      alert('Could not download file.');
    }
  }

  /**
   * Function that get the ressource url for s3
   * @param fileKey key of the file to get the url
   * @returns the s3 url of the specified file
   */
  getResourceUrl(fileKey: string): string {
    return `https://ifm-chat-files.s3.ca-central-1.amazonaws.com/${fileKey}`;
  }

  /**
   * Function that get the message MIME type from the file
   * @param file
   * @returns the message type based on file
   */
  getMessageTypeFromMime(file: File): string {
    const mime = file.type;

    if (mime.startsWith('image/')) {
      return 'image';
    }
    if (mime.startsWith('video/')) {
      return 'video';
    }
    if (mime.startsWith('audio/')) {
      return 'audio';
    }
    if (mime === 'application/pdf') {
      return 'pdf';
    }
    if (mime === 'application/msword') {
      return 'doc';
    }
    if (
      mime ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) {
      return 'docx';
    }
    if (mime === 'application/vnd.ms-excel') {
      return 'xls';
    }
    if (mime.includes('zip')) {
      return 'zip';
    }

    return 'file';
  }
  //
  /**
   * Function that get the message category: image, video, audi, file or text from a message
   * @param message the message
   * @returns the message type
   */
  getMessageCategory(
    message: chatMessage
  ): 'image' | 'video' | 'audio' | 'file' | 'text' {
    const type = message.message_type?.toLowerCase();
    const msg = message.content; // may be remove

    const imageExtensions = [
      'jpg',
      'jpeg',
      'png',
      'gif',
      'webp',
      'bmp',
      'tiff',
      'svg',
      'ico',
    ];
    const textExtensions = [
      'bat',
      'c',
      'cpp',
      'cs',
      'doc',
      'docx',
      'env',
      'go',
      'h',
      'hpp',
      'htm',
      'html',
      'ini',
      'java',
      'js',
      'json',
      'log',
      'md',
      'odt',
      'pdf',
      'php',
      'ps1',
      'py',
      'rb',
      'rs',
      'rtf',
      'sh',
      'sql',
    ];
    const spreadsheetExtensions = ['xls', 'xlsx', 'csv', 'ods'];
    const audioExtensions = ['mp3', 'wav', 'ogg', 'm4a', 'flac', 'aac', 'wma'];
    const videoExtensions = [
      'mp4',
      'mov',
      'avi',
      'wmv',
      'webm',
      'mkv',
      'flv',
      'm4v',
    ];
    const archiveExtensions = ['zip', 'rar', '7z', 'tar', 'gz'];

    if (type?.startsWith('image') || imageExtensions.includes(type)) {
      return 'image';
    }
    if (type?.startsWith('video') || videoExtensions.includes(type)) {
      return 'video';
    }
    if (type?.startsWith('audio') || audioExtensions.includes(type)) {
      return 'audio';
    }

    const fileExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip'];
    const fileName = msg?.toLowerCase() || '';

    if (
      fileExtensions.some((ext) => fileName.endsWith(`.${ext}`)) ||
      archiveExtensions.includes(type) ||
      textExtensions.includes(type) ||
      spreadsheetExtensions.includes(type) ||
      type === 'file'
    ) {
      return 'file';
    }

    return 'text';
  }

  /**
   * Function that get the file extension from a file path
   * @param filePath the path of the file
   * @returns file extension
   */
  getFileExtension(filePath: string): string {
    const parts = filePath.split('.');
    const ext = parts.length > 1 ? parts.pop() : '';
    return ext ? ext.toLowerCase() : '';
  }

  /**
   * Function that sanitize file name
   * @param fileKey
   * @returns
   */
  getSanitizedFileName(fileKey: string): string {
    // Split by '/' to get the last segment (the actual file name)
    const lastSegment = fileKey.split('/').pop();
    // If it contains an underscore, remove the timestamp part
    if (lastSegment && lastSegment.includes('_')) {
      return lastSegment.substring(lastSegment.indexOf('_') + 1);
    }
    // If no underscore found, return as is
    return lastSegment || '';
  }

  /**
   * Function that open the image modal and set the selected image to show in full size
   * @param imageUrl the url of the image to display
   */
  openImageModal(imageUrl: string): void {
    //Safely exist if invalide url
    if (!imageUrl) {
      return;
    }
    this.selectedImage = this.getResourceUrl(imageUrl);
    this.isModalOpen = true;
  }

  /**
   * Function that closes the image modal
   */
  closeImageModal(): void {
    this.isModalOpen = false;
    this.selectedImage = ''; // Clear the image when closing
  }

  /**
   * Function that filters the contact list for a search term considering the roles
   */
  onContactFilterChange(): void {
    // Convert the search term to lowercase
    const searchTerm = this.contactSearch.toLowerCase();
    // Initialize an empty object to hold the filtered results grouped by role
    this.filteredGroupedContacts = {};

    for (const type of this.userTypes) {
      // Get the list of contacts for this role if it exists
      const contacts = this.groupedContacts[type] || [];
      // Filter contacts
      this.filteredGroupedContacts[type] = contacts.filter((contact) =>
        (contact.given_name + ' ' + contact.family_name)
          .toLowerCase()
          .includes(searchTerm)
      );
    }
    this.updateClientGroups(this.filteredGroupedContacts['client'] || []);
  }

  // Current user client ID can arrive as a parsed array or a JSON string.
  private getCurrentClientEntityId(): string {
    if (this.chatService.currentUserAssociatedEntity) {
      return this.chatService.currentUserAssociatedEntity;
    }

    const rawUser = this.currentChatUser?.user;
    if (Array.isArray(rawUser) && rawUser[0]) {
      return (
        rawUser[0].client_id ||
        rawUser[0].associated_entity_id ||
        ''
      );
    }
    if (typeof rawUser === 'string' && rawUser) {
      try {
        const parsed = JSON.parse(rawUser);
        if (Array.isArray(parsed) && parsed[0]) {
          return (
            parsed[0].client_id ||
            parsed[0].associated_entity_id ||
            ''
          );
        }
      } catch {
        return '';
      }
    }
    return '';
  }

  // Rebuilds the client subgroups used under the client tab and keeps expand state.
  private updateClientGroups(contacts: any[]): void {
    const previousExpanded = { ...this.expandedClientGroup };
    this.filteredGroupedClientContacts = {};
    this.clientGroupIds = [];
    this.expandedClientGroup = { ...previousExpanded };
    const currentEntityId = this.getCurrentClientEntityId();
    for (const contact of contacts) {
      const clientId =
        (contact.associated_entity_id || (contact as any).client_id || '')
          .trim() || 'unknown';
      if (this.isUserClient && currentEntityId && clientId !== currentEntityId) {
        continue;
      }
      if (!this.filteredGroupedClientContacts[clientId]) {
        this.filteredGroupedClientContacts[clientId] = [];
        this.clientGroupIds.push(clientId);
        if (this.expandedClientGroup[clientId] === undefined) {
          this.expandedClientGroup[clientId] = false;
        }
      }
      this.filteredGroupedClientContacts[clientId].push(contact);
    }
  }

  ////////////////////////// screen  sharing ////////////////////////////////
  async startScreenShare() {
    const mediaStream = await navigator.mediaDevices.getDisplayMedia({
      video: { cursor: 'always' } as any,
      audio: false,
    });
    await this.screenShareService.startScreenShare(mediaStream);
    // this.isScreenSharing = true;
  }
  // In your callback, after receiving the candidate
  updateUIWithNewCandidate(candidate: string) {
    this.showModal = true;
    this.screenShareService.handleCandidate({
      CONTENT: {
        candidate: candidate,
        target: this.chatRecipient, // You may need to pass in the actual remote user id
        sender: this.userSub, // You may need to pass in the actual local user id
      },
      ACTION: '',
    });
  }
  // This method is called when the user accepts the screen share
  acceptScreenShare() {
    // Hide the modal by setting showModal to false
    this.showModal = false;
    this.isScreenSharing = true;
    // After candidate is processed, attempt to open PiP
    const videoElement = this.screenShareVideoRef.nativeElement;
    if (videoElement) {
      this.screenShareService.setupOnTrackHandler(videoElement);
      videoElement.onloadedmetadata = () => {
        ('[DEBUG] video data received');

        /*  if (videoElement.requestPictureInPicture) {
          // Trigger PiP mode when the video is ready
          videoElement.requestPictureInPicture().catch((err) => {
            console.error('Error enabling Picture-in-Picture', err);
          });
        } */
      };
    } else {
      console.warn('peerConnection or videoElement is missing');
    }
  }
  // This method is called when the user rejects the screen share
  rejectScreenShare() {
    // Hide the modal and log rejection
    this.showModal = false;
    //TODO send rejection to server or WebSocket
    // this.screenShareService.rejectScreenShare(this.chatRecipient, this.userSub);
  }
  stopScreenShare(): void {
    this.isScreenSharing = false;
    this.screenShareService.stopScreenShare();
  }

  //////  END screen share  //////

  /**
   * Function that get the role label for a given role key
   * @param value the key of the role
   * @returns the label of the given role
   */
  getRoleLabel(value: string): string {
    return Roles.find((r) => r.value === value)?.label || '_all';
  }

  /**
   * Function that returns the name and entity type for a user for a given ID if it exists
   * @param Id id of the specific user
   * @returns An object containing name and user type of user
   */
  getEntityInfoById(Id: string): { name: string; type: string } | null {
    //Safely exit if invalid ID
    if (!Id) {
      return null;
    }

    //For client
    if (Id.startsWith('CL')) {
      const client = this.dashboardService.clientArray.find(
        (c: any) => c.client_id === Id
      );
      return {
        name: client ? client.client_name : 'Unknown Client',
        type: '_client',
      };
    }

    //For operator
    if (Id.startsWith('OP')) {
      const operator = this.operatorService.original_operator_array.find(
        (o: any) => o.operator_id === Id
      );
      return {
        name: operator ? operator.operator_name : 'Unknown Operator',
        type: '_operator',
      };
    }

    //For distributor
    if (Id.startsWith('DI')) {
      const distributor = this.dashboardService.distributorArray.find(
        (d: any) => d.distributor_id === Id
      );
      return {
        name: distributor
          ? distributor.distributor_name
          : 'Unknown Distributor',
        type: '_distributor',
      };
    }

    // Fallback for unrecognized prefixes
    return { name: 'Unknown Entity', type: 'unknown' };
  }

  /**
   * Function that initialize the chat window resizing
   * @param event Mouseevent
   * @param edge the edge that triggered the resizing
   */
  startEdgeResize(
    event: MouseEvent,
    edge:
      | 'left'
      | 'right'
      | 'top'
      | 'bottom'
      | 'corner-top-left'
      | 'corner-bottom-right'
      | 'corner-bottom-left'
      | 'corner-top-right'
  ): void {
    this.resizing = true;
    this.resizeEdge = edge;

    //Get the chat window and its settings
    const chatElement = this.chatWindowRef.nativeElement;
    this.startX = event.clientX;
    this.startY = event.clientY;
    this.startWidth = chatElement.offsetWidth;
    this.startHeight = chatElement.offsetHeight;
    this.startTop = chatElement.offsetTop;
    this.startLeft = chatElement.offsetLeft;

    chatElement.classList.add('resizing');

    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Function that init all ws subscription
   */
  initWebSocketSubscriptions(): void {
    this.webSocketService.subscribe(this.wsLiveChat); // subscribe to WS for chat messages
    this.webSocketService.subscribe(this.wsLiveChatStatus); // subscribe to WS for user status
    this.webSocketService.subscribe(this.wsScreenShareOffer); // subscribe to WS for screen share offer
    this.webSocketService.subscribe(this.wsScreenShareAnswer); // subscribe to WS for screen share answer
    this.webSocketService.subscribe(this.wsIceCandidate); // subscribe to WS for ice candidate message

    this.webSocketService.subscribe(this.wsLogOut); // subscribe to WS for LOG OUT updates
    this.webSocketService.subscribe(this.wsLogIn); // subscribe to WS for LOG IN updates
    this.webSocketService.subscribe(this.wsMessageRead); // subscribe to WS for message read
    this.webSocketService.subscribe(this.wsContactListStatuses); // subscribe to WS for contact statuses
    this.webSocketService.subscribe(this.wsMessageReadSync); // subscribe to WS for message read sync
    this.webSocketService.subscribe(this.wsMessageSync); // subscribe to WS for message  sync
    this.webSocketService.subscribe(this.wsNewConversation); // subscribe to WS for new conversations
    this.webSocketService.subscribe(this.wsNewConversationSync); // subscribe to WS for new conversations sync
    this.webSocketService.subscribe(this.wsContactStatusChange); // subscribe to WS for contact status change
  }
  /**
   * Function that destroy all ws subscription to avoid data leak
   */
  destroyWebSocketSubscriptions(): void {
    this.webSocketService.unsubscribe(this.wsLiveChat); // unsubscribe to the WS
    this.webSocketService.unsubscribe(this.wsLiveChatStatus); // unsubscribe to the WS
    this.webSocketService.unsubscribe(this.wsScreenShareOffer); // unsubscribe to WS for screen share offer
    this.webSocketService.unsubscribe(this.wsScreenShareAnswer); // unsubscribe to WS for screen share answer
    this.webSocketService.unsubscribe(this.wsIceCandidate); // unsubscribe to WS for ice candidate message
    this.webSocketService.unsubscribe(this.wsLogOut); // unsubscribe to WS for LOG OUT updates
    this.webSocketService.unsubscribe(this.wsLogIn); // unsubscribe to WS for LOG IN updates
    this.webSocketService.unsubscribe(this.wsMessageRead); // unsubscribe to WS for message read
    this.webSocketService.unsubscribe(this.wsContactListStatuses); // unsuscribe to WS for contact statuses
    this.webSocketService.unsubscribe(this.wsMessageReadSync); // unsuscribe to WS for message read sync
    this.webSocketService.unsubscribe(this.wsMessageSync); // unsuscribe to WS for message sync
    this.webSocketService.unsubscribe(this.wsNewConversation); // unsuscribe to WS for new conversations
    this.webSocketService.unsubscribe(this.wsNewConversationSync); // unsuscribe to WS for new conversations sync
    this.webSocketService.unsubscribe(this.wsContactStatusChange); // unsuscribe to WS for contact status change
  }
  /**
   * Function that capitalize the first letter of a string
   * @param str the string passed
   * @returns the string with its first letter capitalized
   */
  capitalizeFirstLetter(str: string): string {
    if (!str) {
      return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  /**
   * Function that disable the drag event, place this function in the
   * (click) property of the HTML element where drag should be disabled
   * @param event mouse event
   */
  disableDrag(event: MouseEvent): void {
    event.stopPropagation();
  }
  /**
   * Function that copies the text content of message to the clipboard
   * @param content - The text to copy
   */
  copyToClipboard(content: string): void {
    if (!content) {
      return;
    }
    //this.systemMessageService.selectRibbon('success',"ctrl-c")
    this.textCopied = true;
    navigator.clipboard
      .writeText(content)
      .then(() => {
        setTimeout(() => {
          this.textCopied = false;
        }, 1500);
        // Optionally show a toast or UI feedback
      })
      .catch((err) => {
        console.error('Failed to copy:', err);
      });
    if (this.showContactInfo) {
      this.showContactInfo = false;
    }
  }
  handleChatOpened(event: CustomEvent<any>): void {
    this.openConversation(event.detail.conversation);
  }
  openVideoModal(url: string) {
    this.selectedVideoUrl = url;
    this.isVideoModalOpen = true;
  }
  closeVideoModal() {
    this.isVideoModalOpen = false;
    this.selectedVideoUrl = null;
  }

  /**
   * Handles selecting a conversation tab.
   * When a tab is clicked, it opens the corresponding conversation.
   */
  selectTab(tab: any) {
    this.openConversation(tab.sub);
  }

  /**
   * Handles closing a conversation tab.
   * Stops event propagation to avoid triggering tab selection on close.
   */
  closeConvoTab(tab: any, event: MouseEvent) {
    event.stopPropagation(); // prevent triggering selectTab

    // Remove tab from list
    this.tabs = this.tabs.filter((openedTab) => openedTab.sub !== tab.sub);

    // If the closed tab was active, activate the next available tab (if any)
    if (this.activeTab.sub === tab.sub) {
      //Opens first listed tab
      let newTab = this.tabs[0] || null;
      if (newTab) {
        this.openConversation(newTab.sub);
      }
    }

    // Resets views when no active tab / convo
    if (this.tabs.length === 0) {
      //Updates the view
      this.chatRecipient = null;
      this.currentConversationID = '';
      this.chatLog = undefined;
      this.chatBanner = undefined;
    }
  }
  wsLiveChatStatusHandler(msg:any){
    const contact = this.findContactByUserId(this.filteredGroupedContacts, msg['CONTENT']['USER'])
    contact.status = msg['CONTENT']['TYPE']
  }
  findContactByUserId(contacts: any, userId: string) {

  return contacts._all.find((contact: any) => contact.user === userId);
}
getStatusColor(status: boolean | string | undefined): string {
  if (typeof status === 'string') {
    // Check if it's a known status
    return this.inactivityService.statusColors[status] ?? 'grey';
  }

  if (typeof status === 'boolean') {
    // Interpret boolean: true = available, false = offline
    return status ? this.inactivityService.statusColors['_available'] : this.inactivityService.statusColors['_offline'];
  }

  // Default color for undefined/null
  return 'grey';
}
}
